const wrap = require('word-wrap')
const { fountainRegex } = require('./regex')
const structureTypes = require('./structureTypes')
const types = Object.keys(structureTypes)

function lexer (script, isProse) {
  // when converting to prose, multiline comments should be preserved
  if (!isProse) script = script.replace(fountainRegex.boneyard, '')

  return script
    .replace(fountainRegex.standardizer, '\n')
    .replace(fountainRegex.cleaner, '')
    .split(fountainRegex.splitter)
}

function parser (script, callback, isProse) {
  const src = lexer(script, isProse)
  let tokens = []
  let dual
  let dualLength = 0

  const boneyard = fountainRegex.boneyard.test(script)
  let inBoneyard = false
  let currentBoneyard = []

  for (let i = src.length - 1; i > -1; i--) {
    // original input is kept because action element honors indentation.
    // all white spaces are removed before sent to structureTypes checker.
    let originalLine = src[i]
    const line = originalLine.replace(fountainRegex.whitespacer, '')

    // multiline comment checks need to happen before structureType checking
    // because the contents of the comment might include recognizable element types
    if (boneyard) {
      if (line.startsWith('/*') && line.endsWith('*/')) {
        // unpadded multiline comments are parsed in their entirety,
        // treated as an action and short circuit additional checks
        tokens.unshift({ type: 'note', text: originalLine })
        continue
      } else if (line.endsWith('*/')) {
        // the termination of a multiline comment is checked first
        // because the script is parsed in reverse order
        inBoneyard = true
      } else if (line.startsWith('/*')) {
        // when the opening of a multiline comment is encountered
        // its time to insert the whole thing as a note, reset and short circuit
        currentBoneyard.push(originalLine)
        tokens.unshift({ type: 'note', text: currentBoneyard.reverse().join('\n') })
        inBoneyard = false
        currentBoneyard = []
        continue
      }

      // append both terminated and interior multiline comments
      // to the array and short circuit additional checks
      if (inBoneyard) {
        currentBoneyard.push(originalLine)
        continue
      }
    }

    for (let j = 0; j <= types.length; j++) {
      if (j === types.length) {
        // if user use `!`` to force line as action, remove `!`
        if (originalLine.match(/^!.*/)) {
          // TODO: ensure !TRANSITION is interpreted as an ACTION
          originalLine = originalLine.substr(1)
        }
        // it is action, so use original input that may contain indentation.
        const toWrap = originalLine.replace(/\S{60}/g, '$& ')
        const wrapped = wrap(toWrap, { width: 60, indent: '' })
        const lines = wrapped.split('\n').length + 1
        tokens.unshift({ type: 'action', text: originalLine, input: originalLine, wrapped, lines, blanks: 1 })
        break
      }
      const match = line.match(fountainRegex[types[j]])
      if (match) {
        const contents = structureTypes[types[j]](match, dual, line)
        for (let n = 0; n < contents.length; n++) {
          if (contents[n].text) {
            contents[n].input = contents[n].text
          }
          if (contents[n].dual && contents[n].dual === 'right') {
            dualLength = contents[n].raw_lines
          }
          if (contents[n].type === 'dual_dialogue_end') {
            dual = 'left'
          }
          if (contents[n].type === 'dual_dialogue_begin') {
            dual = undefined
            if (contents[n].lines < dualLength) {
              contents[n].lines = dualLength // use the right-side length instead
            }
            dualLength = 0
          }
        }
        tokens = contents.concat(tokens)
        break
      }
    }
  }

  return callback(tokens)
}

module.exports = { parser }
